<template>
	<SecondaryButton @click="handleClick">
		<ArrowLeftIcon/>
		{{ buttonText }}
	</SecondaryButton>
</template>

<script>
/*import { useI18n } from "vue-i18n";
import { computed } from "vue";*/
import { hideAllModals, hideAllOffcanvas, hideModal, hideOffcanvas } from "@/utils";
import SecondaryButton from "@/components/ui/buttons/variants/SecondaryButton.vue";
import ArrowLeftIcon from "@/components/core/icons/ArrowLeftIcon.vue";

export default {
	name: "DismissButton",
	components: {ArrowLeftIcon,  SecondaryButton },
	props: {
		isModal: {
			type: Boolean,
			default: true,
		},
		modalId: {
			type: String,
			default: "",
		},
		contentBtnText: {
			type: String,
			default: "",
		},
		onClick: {
			type: Function,
			default: null,
		},
	},
/*	setup(props) {
		const { t } = useI18n();

		const buttonText = computed(() => {
			return props.contentBtnText || t("menu.orderCloseButton");
		});

		return { buttonText };
	},*/
	methods: {
		handleClick() {
			if (this.onClick) {
				this.onClick();
			}

			if (this.isModal && this.modalId) {
				hideModal(this.modalId);
			}

			if (this.isModal && !this.modalId) {
				hideAllModals();
			}

			if (!this.isModal && this.modalId) {
				hideOffcanvas(this.modalId);
			}

			if (!this.isModal && !this.modalId) {
				hideAllOffcanvas();
			}
		},
	},
};
</script>
